import type { PaymentStatus } from "@/types";
import {
  DURATION,
  EFFORT,
  EXPERIENCE_LEVEL,
  jobCategoryEnum,
  PaymentType,
  REMOTE_POLICY,
  START_DATE,
} from "../create/constants";
import type { AllowedFilters, AllowedSortFields } from "../types";

export const ALLOWED_FILTERS = [
  "daily_rate_min",
  "daily_rate_max",
  "skills",
  "job_category",
  "experience_level",
  "duration",
  "effort",
  "budget",
  "payment_type",
  "renewable",
  "remote_policy",
  "start_date",
] satisfies AllowedFilters[];

export const GENERAL_FILTERS = [
  "skills",
  "job_category",
  "duration",
  "effort",
  "remote_policy",
  "start_date",
  "experience_level",
  "renewable",
] satisfies AllowedFilters[];

export const FILTERS_CONFIG = {
  renewable: {
    label: "Contratto rinnovabile",
    key: "renewable",
    type: "radio-group",
    options: ["true", "false", "all"],
    placeholder: "Renewable",
  },
  remote_policy: {
    label: "Remote policy",
    key: "remote_policy",
    type: "array",
    options: REMOTE_POLICY,
    placeholder: "Seleziona modalità remota",
  },
  start_date: {
    label: "Data di inizio",
    key: "start_date",
    type: "array",
    options: START_DATE,
    placeholder: "Seleziona data di inizio",
  },
  daily_rate_min: {
    label: "Tariffa giornaliera minima",
    key: "daily_rate_min",
    type: "string",
    options: [],
    placeholder: "Tariffa giornaliera minima",
  },
  daily_rate_max: {
    label: "Tariffa giornaliera massima",
    key: "daily_rate_max",
    type: "string",
    options: [],
    placeholder: "Tariffa giornaliera massima",
  },
  skills: {
    label: "Skills",
    key: "skills",
    type: "tag",
    options: [],
    placeholder: "Inserisci skills",
  },
  job_category: {
    label: "Settore",
    key: "job_category",
    type: "array",
    options: jobCategoryEnum,
    placeholder: "Seleziona settore",
  },
  experience_level: {
    label: "Livello di esperienza",
    key: "experience_level",
    type: "array",
    options: EXPERIENCE_LEVEL,
    placeholder: "Seleziona livello di esperienza",
  },
  payment_status: {
    label: "Stato di pagamento",
    key: "payment_status",
    type: "array",
    options: ["pending", "completed", "failed"] satisfies PaymentStatus[],
    placeholder: "Seleziona stato di pagamento",
  },
  duration: {
    label: "Durata",
    key: "duration",
    type: "array",
    options: DURATION,
    placeholder: "Seleziona durata",
  },
  effort: {
    label: "Impegno orario",
    key: "effort",
    type: "array",
    options: EFFORT,
    placeholder: "Seleziona impegno orario",
  },
  budget: {
    label: "Budget minimo",
    key: "budget",
    type: "string",
    options: [],
    placeholder: "Budget minimo",
  },
  payment_type: {
    label: "Tipo di pagamento",
    key: "payment_type",
    type: "array",
    options: [PaymentType.DAILY, PaymentType.FIXED],
    placeholder: "Seleziona tipo di pagamento",
  },
} satisfies Record<
  Exclude<AllowedFilters, "search" | "project_type">,
  {
    label: string;
    key: AllowedFilters;
    type: "string" | "array" | "tag" | "radio-group";
    options?: readonly string[];
    placeholder?: string;
  }
>;

export const ALLOWED_SORT_FIELDS = [
  "created_at",
  "updated_at",
  "views_count",
  "applications_count",
] satisfies AllowedSortFields[];

export const ALLOWED_SORT_CONFIG = {
  created_at: {
    label: "Creato il",
    key: "created_at",
  },
  updated_at: {
    label: "Aggiornato il",
    key: "updated_at",
  },
  views_count: {
    label: "Visualizzazioni",
    key: "views_count",
  },
  applications_count: {
    label: "Candidature",
    key: "applications_count",
  },
} satisfies Record<
  Exclude<AllowedSortFields, "budget" | "estimated_deadline" | "project_end">,
  { label: string; key: AllowedSortFields }
>;
